import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { actions, selectors } from 'src/store';
import { paths } from 'src/constants';
import { useIntlMessages } from 'src/hooks';

import { Container } from './components';

const FindWordsStepThreeExtraCollections = ({
  findWordsStepThreeExtraCollections,
  findWordsStepThreeExtraCurrency,
  getCollections,
  hasLoaded,
  pageCount,
  student,
}) => {
  const messages = useIntlMessages();

  return (
    <Container
      className="find-words-collections-container--step-three-extra"
      collectionsPath={paths.FIND_WORDS_STEP_THREE_EXTRA}
      currency={findWordsStepThreeExtraCurrency}
      getCollections={getCollections}
      hasLoaded={hasLoaded}
      items={findWordsStepThreeExtraCollections}
      levelsPath={paths.FIND_WORDS_STEP_THREE_EXTRA_LEVELS}
      pageCount={pageCount}
      student={student}
      title={messages.game.findWords}
    />
  );
};

FindWordsStepThreeExtraCollections.propTypes = {
  getCollections: PropTypes.func.isRequired,
  hasLoaded: PropTypes.bool.isRequired,
  findWordsStepThreeExtraCollections: PropTypes.arrayOf(PropTypes.shape({}))
    .isRequired,
  findWordsStepThreeExtraCurrency: PropTypes.shape({}).isRequired,
  pageCount: PropTypes.number.isRequired,
  student: PropTypes.shape({}).isRequired,
};

const mapStateToProps = (state) => ({
  hasLoaded: selectors.findWordsStepThreeExtraCollections.getHasLoaded(state),
  findWordsStepThreeExtraCurrency: selectors.findWordsStepThreeExtraCollections.getCurrencyData(
    state
  ),
  findWordsStepThreeExtraCollections: selectors.findWordsStepThreeExtraCollections.getCollectionsData(
    state
  ),
  pageCount: selectors.findWordsStepThreeExtraCollections.getPageCount(state),
  student: selectors.authentication.getStudent(state),
});

const mapDispatchToProps = {
  ...actions.findWordsStepThreeExtra,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  memo
)(FindWordsStepThreeExtraCollections);
